"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isWindowAvailable = void 0;
const isWindowAvailable = () => typeof window != 'undefined' && typeof (window === null || window === void 0 ? void 0 : window.location) != 'undefined';
exports.isWindowAvailable = isWindowAvailable;
//# sourceMappingURL=isWindowAvailable.js.map